import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Search from './Pages/Search';

import Timeline from './Pages/Timeline'
import Profile from './Pages/Profile';
import Settings from './Pages/Settings';
import Home from './Pages/Home';

function Routes() {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/timeline" component={Timeline} />
                <Route path="/search" component={Search} />
                <Route path="/profile/:id" component={Profile} />
                <Route path="/settings" component={Settings} />
            </Switch>
        </BrowserRouter>
    )
}

export default Routes;